import type { OptionCategoryRowResponse } from "../api/optionCategories";
import type { ConnectedEntityFormType, OptionCategoryListItem } from "./types";

const countConnections = (
  connectedEntities: OptionCategoryRowResponse["connectedEntities"],
  formType: ConnectedEntityFormType
) =>
  connectedEntities
    .filter(connectedEntity => connectedEntity.formType === formType)
    .reduce((total, { numberOfConnections }) => total + numberOfConnections, 0);

export const toOptionCategoryListItem = (
  option: OptionCategoryRowResponse,
  usageFormTypes: Array<ConnectedEntityFormType>
): OptionCategoryListItem => ({
  id: option.id,
  value: option.value,
  label: option.label,
  description: option.metadata?.description,
  usage: usageFormTypes
    .map(formType => ({ formType, count: countConnections(option.connectedEntities, formType) }))
    .filter(({ count }) => count > 0),
  canBeEdited: option.canBeEdited,
  isInUse: option.isInUse,
  isShared: option.isShared ?? false,
});
